<template>
  <div class="px-4">
    <v-expansion-panels v-model="open" flat class="user-filters" accordion>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="font-18">Пользовательские фильтры</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-0">
          <v-row no-gutters align="center">
            <!-- {{ selectedFilter }} -->
            <v-combobox
              v-model="selectedFilter"
              outlined
              hide-details
              dense
              label="Фильтр"
              placeholder="Выберите фильтр или введите название для нового"
              clearable
              item-value="id"
              item-text="name"
              :items="filters"
              :loading="loading"
            >
              <template #item="{ item }">
                <v-row no-gutters>
                  {{ item.name }}
                  <v-spacer />
                  <v-icon
                    v-if="item.selected"
                    color="primary"
                    small
                    v-text="`mdi-star`"
                  />
                </v-row>
              </template>
            </v-combobox>
            <v-btn
              icon
              class="ml-2"
              v-bind="bindFavorite"
              title="Сохранить фильтр"
              :disabled="!selectedFilter"
            >
              <v-icon v-text="`mdi-star`" />
            </v-btn>
            <v-btn
              icon
              color="primary"
              title="Сохранить фильтр"
              :disabled="!selectedFilter"
            >
              <v-icon @click="saveFilter" v-text="`mdi-content-save`" />
            </v-btn>
          </v-row>
        </v-expansion-panel-content>
        <v-divider />
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      default: false,
      type: Boolean
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedFilter: null,
      open: null
    };
  },
  computed: {
    bindFavorite() {
      const { selectedFilter } = this;
      if (!selectedFilter) return;
      return {
        color: selectedFilter.selected ? "primary" : "gray"
      };
    }
  },
  watch: {
    filters(v) {
      const filter = v.find(i => i.selected);

      this.selectedFilter = filter;
    }
  },
  methods: {
    applyFilter() {},
    saveFilter() {
      this.$emit("save", this.selectedFilter);
    }
  }
};
</script>

<style lang="scss">
.user-filters {
  .v-expansion-panel-header {
    padding: 0 !important;
    margin-top: 10px;
    margin-bottom: 5px;
    color: rgba(0, 0, 0, 0.6);
    min-height: 35px;
  }
  .v-expansion-panel--active > .v-expansion-panel-header {
    min-height: 35px;
  }
  .v-expansion-panel-content__wrap {
    padding: 0 0 15px 0 !important;
  }
}
</style>
